import ScanHistoryPanel from "./scanHistoryPanel.container"

export default ScanHistoryPanel
